<template>
  <div>
    <nav-bar/>
    <search-bar/>

    <div class="page">
      <div class="pl20 pt10 pb10 bg_white mt20">修改客户信息</div>

      <el-tabs class="mt20 bg_white" v-model="tab" type="border-card">
        <el-tab-pane label="基础信息" name="1">

          <el-form label-width="170px" style="width: 600px;">
            <el-form-item label="公司名称">
              <el-input v-model="submit_form.company_name" class="input"></el-input>
            </el-form-item>
            <el-form-item label="公司地址">
              <select-address-cascader v-model="address"/>

              <div class="mt20">
                <el-input
                    v-model="submit_form.company_address"
                    rows="4"
                    class="input"
                    placeholder="详细地址"
                    type="textarea"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item label="公司电话">
              <tel-input :value.sync="submit_form.company_tel"/>
              <!--                <el-input v-model="submit_form.company_tel" class="input"></el-input>-->
            </el-form-item>

            <el-form-item label="代表人">
              <el-input v-model="submit_form.agent_name" class="input"></el-input>
            </el-form-item>


            <el-form-item label="公司统一社会信用代码">
              <el-input v-model="submit_form.company_taxno" class="input"></el-input>
            </el-form-item>

            <el-form-item label="开户银行">
              <el-input v-model="submit_form.company_bank_name" class="input"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
              <el-input v-model="submit_form.company_bank_no" class="input"></el-input>
            </el-form-item>
          </el-form>

          <div class="fr jc ac mb50 mt50">
            <el-button style="width: 315px" type="primary" @click="next">下一步</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="资质信息" name="2">
          <el-form label-width="80px">
            <el-form-item label="公司logo:">
              <upload-img :file_list.sync="submit_form.company_logo" :limit="1"></upload-img>
            </el-form-item>
            <el-form-item label="其他证照:">
              <div style="color: #666666">图片仅支持.jpeg、.png格式</div>
              <upload-img :file_list.sync="submit_form.company_certificate_imgs" :limit="5"></upload-img>
            </el-form-item>
          </el-form>
          <div class="fr jc ac mb50 mt50">
            <el-button style="width: 315px" type="primary" @click="tab = '3'">下一步</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="匹配信息" name="3">
          <el-form label-width="170px" style="width: 600px;">
            <el-form-item label="客户分类:">
              <el-radio-group v-model="submit_form.source" class="source fw">
                <el-radio label="machinery_manufacturers">机械厂商</el-radio>
                <el-radio label="middleman">中间商</el-radio>
                <el-radio label="end_user">最终用户</el-radio>
                <el-radio label="foreign_users">国外用户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="客户归属:">
              <el-radio-group v-model="submit_form.company_attribution" class="source fw">
                <el-radio label="kaiyao">凯耀</el-radio>
                <el-radio label="yifa">益发</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="行业信息:">
              <el-cascader
                  v-if="current_select_industry.length !== 0"
                  v-model="current_select_industry"
                  :props="industry_props"
                  :options="industry_list"
                  @change="onIndustryChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="行业信息:">
              <el-cascader
                  v-if="current_select_industry.length !== 0"
                  v-model="current_select_industry"
                  :props="industry_props"
                  :options="industry_list"
                  @change="onIndustryChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="设备信息:">
              <el-select
                  v-model="current_select_device"
                  placeholder="请选择"
                  @change="onDeviceChange"
              >
                <el-option
                    v-for="item in device_list"
                    :key="item.class_id"
                    :label="item.class_name"
                    :value="item.class_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备型号:" v-if="false">
              <el-select
                  v-model="current_select_device_types"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in device_type_list"
                    :key="item.device_id"
                    :label="item.device_name"
                    :value="item.device_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产原料:">
              <el-select
                  v-model="submit_form.raw_material"
                  multiple
                  collapse-tags
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in raw_material_list"
                    :key="item.id"
                    :label="item.tag_name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产废料:">
              <el-select
                  v-model="submit_form.waste_material"
                  multiple
                  collapse-tags
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in waste_material_list"
                    :key="item.id"
                    :label="item.tag_name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产产品:">
              <el-select
                  v-model="submit_form.product"
                  multiple
                  collapse-tags
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in product_list"
                    :key="item.id"
                    :label="item.tag_name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="fr jc ac" style="margin-bottom: 80px;margin-top: 100px">
            <el-button type="primary" style="width: 315px" @click="submit">保存</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <footer-bar/>
  </div>
</template>

<script>

import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  data() {
    return {
      raw_material_list: [],
      waste_material_list: [],
      product_list: [],
      //当前选中的三级行业
      current_select_industry: [],
      is_count_down: false,
      count_down: 60,
      //协议弹窗
      protocol_show: false,
      tab: "1",
      industry_props: {
        value: "industry_id",
        label: "industry_name",
        children: "insustryBeans",
      },
      // 三级行业信息
      industry_list: [],
      //二级设备信息
      device_list: [],
      //当前选择的设备
      current_select_device: "",

      //设备型号
      device_type_list: [],
      //选择的型号
      current_select_device_types: "",

      //原料
      raw_material_name: "",
      //废料
      waste_material_name: "",
      //产品
      product_name: "",

      //北京市 / 市辖区 / 西城区
      address: [],
      //提交表单信息
      submit_form: {
        company_name: "",
        company_logo: [],
        company_province: "",
        company_city: "",
        company_country: "",
        company_address: "",
        company_tel: "",
        company_taxno: "",
        company_bank_name: "",
        company_bank_no: "",
        contact_name: "",
        contact_mobile: "",
        contact_position: "",
        company_certificate_imgs: [],
        company_remark: "",

        industry_id1: "",
        industry_name1: "",
        industry_id2: "",
        industry_name2: "",
        source: "",
        industry_id3: "",
        industry_name3: "",
        device_ids: "",
        company_attribution: "",
        device_names: "",

        //原料
        raw_material: [],
        //废料
        waste_material: [],
        //产品
        product: [],
      },
      position_options: ["负责人", "财务", "采购", "技术员"],
    };
  },
  mounted() {
    this.getCompanyDetail();

    //  获取行业信息
    this.getIndustryList();
  },
  methods: {
    getCompanyTagList(tag_type) {
      return this.post("companyTag/getCompanyTagList", {
        company_id: this.$route.query.company_id,
        tag_type,
        page: -1,
        pageSize: -1
      });
    },
    getTagList(tag_type) {
      return this.post("tag/getTagList", {
        company_id: this.$route.query.company_id,
        tag_type,
        page: -1,
        pageSize: -1
      });
    },
    //   获取客户详情
    async getCompanyDetail() {
      let res = await this.post("memberInterfaces/v1.0/getSellCompany", {
        company_id: this.$route.query.company_id,
      })
      let obj = res.data;
      obj.company_certificate_imgs = this.strToArr(obj.company_certificate_imgs)
      //设置公司详情
      this.address.push(obj.company_province);
      if (obj.company_province === obj.company_city) {
        this.address.push("市辖区");
      } else {
        this.address.push(obj.company_city);
      }
      if (!this.is_Empty(obj.company_country)) {
        this.address.push(obj.company_country);
      }
      obj.company_logo = this.strToArr(obj.company_logo)
      obj.company_certificate_imgs = this.strToArr(obj.company_certificate_imgs)

      let current_select_industry = [
        Number(obj.industry_id1),
        Number(obj.industry_id2),
        Number(obj.industry_id3),
      ];

      this.getDeviceList(obj.industry_id3);

      this.current_select_industry = current_select_industry;

      let tags = await this.getTagList(1);
      this.raw_material_list = tags.data;
      tags = await this.getTagList(2);
      this.waste_material_list = tags.data;
      tags = await this.getTagList(3);
      this.product_list = tags.data;
      obj.raw_material = this.strToArr(obj.raw_material)
      obj.waste_material = this.strToArr(obj.waste_material)
      obj.product = this.strToArr(obj.product)
      this.submit_form = obj;
    },
    //添加原料
    addRawMaterial() {
      if (!this.raw_material_name) {
        this.$message("请输入名称");
        return;
      }
      this.submit_form.raw_material.push(this.raw_material_name);
      this.raw_material_name = "";
    },

    // /添加废料
    addWastMaterial() {
      if (!this.waste_material_name) {
        this.$message("请输入名称");
        return;
      }
      this.submit_form.waste_material.push(this.waste_material_name);
      this.waste_material_name = "";
    },
    //添加产品
    addProduct() {
      if (!this.product_name) {
        this.$message("请输入名称");
        return;
      }
      this.submit_form.product.push(this.product_name);
      this.product_name = "";
    },

    //设备选中 获取型号
    onDeviceChange(class_id) {
      this.device_list.forEach((item) => {
        if (item.class_id == class_id) {
          this.device_type_list = item.deviceBeans;
        }
      });
    },

    //三级行业炫选中
    onIndustryChange(select_industry) {
      // 通过三级行业id获取设备id
      this.getDeviceList(select_industry[2]);
    },
    //获取行业三级
    getIndustryList() {
      this.post("goodsInterfaces/v1.0/getIndustrys").then((res) => {
        this.industry_list = res.data;
      });
    },
    //获取三级设备
    getDeviceList(industry_id3) {
      let param = {
        industry_id: industry_id3,
      };
      this.post("goodsInterfaces/v1.0/getIndustryDevice", param).then((res) => {
        this.device_list = res.data;
      });
    },
    //    下一步
    next() {
      if (!this.submit_form.company_name) {
        this.$message("请输入公司名称");
        return;
      }
      if (this.address.length == 0) {
        this.$message("请输入公司地址");
        return;
      }
      if (!this.submit_form.company_address) {
        this.$message("请输入详细地址");
        return;
      }
      if (!this.submit_form.agent_name) {
        this.$message("请输入代表人");
        return;
      }

      this.tab = "2";
    },

    //    提交
    submit() {
      if (!this.submit_form.company_name) {
        this.$message("请输入公司名称");
        return;
      }
      if (this.address.length == 0) {
        this.$message("请输入公司地址");
        return;
      }
      if (!this.submit_form.company_address) {
        this.$message("请输入详细地址");
        return;
      }
      // if (!this.submit_form.company_tel) {
      //   this.$message("请输入公司电话");
      //   return;
      // }
      if (!this.submit_form.agent_name) {
        this.$message("请输入代表人");
        return;
      }


      this.confirmSubmit();
    },

    //    同意协议
    confirmSubmit() {
      let param = Object.assign({}, this.submit_form);

      //设置三级行业 名称和 id
      this.industry_list.forEach((industry1) => {
        //选中的行业  1
        if (industry1.industry_id == this.current_select_industry[0]) {
          param.industry_id1 = industry1.industry_id;
          param.industry_name1 = industry1.industry_name;
          industry1.insustryBeans.forEach((industry2) => {
            //选中的行业  2
            if (industry2.industry_id == this.current_select_industry[1]) {
              param.industry_id2 = industry2.industry_id;
              param.industry_name2 = industry2.industry_name;

              industry2.insustryBeans.forEach((industry3) => {
                //选中的行业  3

                if (industry3.industry_id == this.current_select_industry[2]) {
                  param.industry_id3 = industry3.industry_id;
                  param.industry_name3 = industry3.industry_name;
                }
              });
            }
          });
        }
      });

      //设置设备类型 名称和id
      let device_ids = [];

      let device_names = [];
      this.device_list.forEach((device) => {
        if (device.class_id == this.current_select_device) {
          device.deviceBeans.forEach((item) => {
            this.current_select_device_types.forEach((device_id) => {
              if (device_id == item.device_id) {
                device_ids.push(item.device_id);
                device_names.push(item.device_name);
              }
            });
          });
        }
      });

      param.company_province = this.address[0];
      param.company_city = this.address[1];
      param.company_country = this.address[2];
      param.company_logo = param.company_logo.join(",");
      param.company_certificate_imgs = param.company_certificate_imgs.join(",");
      param.device_ids = device_ids.join(",");
      param.device_names = device_names.join(",");

      param.raw_material = param.raw_material.join(",");
      param.waste_material = param.waste_material.join(",");
      param.product = param.product.join(",");

      let obj = {};
      obj.company_name = param.company_name;
      obj.company_logo = param.company_logo;
      obj.company_province = param.company_province;
      obj.company_city = param.company_city;
      obj.company_country = param.company_country;
      obj.company_address = param.company_address;
      obj.company_tel = param.company_tel;
      obj.agent_name = param.agent_name;

      obj.company_taxno = param.company_taxno;
      obj.company_bank_name = param.company_bank_name;
      obj.company_bank_no = param.company_bank_no;
      obj.contact_name = param.contact_name;
      obj.contact_mobile = param.contact_mobile;
      obj.contact_position = param.contact_position;
      obj.company_certificate_imgs = param.company_certificate_imgs;
      obj.company_remark = param.company_remark;
      obj.company_id = param.company_id;
      obj.industry_id1 = param.industry_id1;
      obj.industry_id2 = param.industry_id2;
      obj.industry_id3 = param.industry_id3;
      obj.device_ids = param.device_ids;
      obj.raw_material = param.raw_material;
      obj.waste_material = param.waste_material;
      obj.product = param.product;
      obj.company_fax = param.company_fax;
      obj.source = param.source;
      obj.company_attribution = param.company_attribution;
      this.post("companyInterfaces/v1.0/sellUpdateCompany", obj).then((res) => {
        this.$message("提交成功");
        this.back();
      });
    },
  },
  components: {
    "nav-bar": NavBar,
    "search-bar": SearchBar,
    "footer-bar": FooterBar,
  },
};
</script>

<style scoped lang="scss">
.page {
  width: 1200px;
  font-size: 14px;
  margin: 0 auto;
  //margin-bottom: 138px;
}

.el-form {
  .el-input, .el-select, .el-cascader {
    width: 100%;
  }
}

.form {
  //.input {
  //  width: 381px;
  //}

  & > > > .el-form-item__label {
    width: 150px;
    white-space: nowrap;
  }
}

.label-list {
  width: 678px;
  height: 108px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  padding: 20px;
  margin-top: 20px;
  flex-wrap: wrap;

  .item {
    margin-left: 10px;
    margin-top: 10px;
    padding: 0 5px;
    height: 34px;
    background: rgba(217, 217, 217, 1);
    opacity: 1;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .delete-icon {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 16px;
      height: 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/myCustomer/updateCustomer.vue